import { request } from "@/utils/requestUtils";
import type { Page } from "@/utils/requestUtils";
import type {
  TransferDetail,
  BillOfMaterial,
  TransferOrder,
  WarehouseMaterialApply,
  TransferPosition,
  ShippingMaterials,
} from "./type";

// 物料列表
export async function getMaterialTypeList(data: any) {
  const res = await request({
    service: "oam-admin",
    url: "/material_type/list",
    method: "POST",
    data,
  });

  // 武颖说的特殊逻辑
  if (res.success && res.model?.result) {
    res.model?.result.forEach((v) => {
      if (v.materialOrigin === 1 && v.platformMaterialCode) {
        v.materialCode = v.platformMaterialCode;
      }
    });
  }
  return res;
}
//获取目标仓位
export async function getTargetPositionList(data: any) {
  return request<Page<TransferPosition>>({
    service: "oam-admin",
    url: "/position/transfer/list",
    method: "POST",
    data,
  });
}

// 调拨审批列表
export async function getMaterialApplyList(data: any) {
  return request({
    service: "oam-admin",
    url: "/material/apply/list",
    method: "POST",
    data,
  });
}

// 创建
export async function createTransferApply(data: any) {
  return request({
    service: "oam-admin",
    url: "/material/apply/save",
    method: "POST",
    data,
  });
}

// 详情

export async function getMaterialApplyInfo(id: string) {
  return request<TransferDetail>({
    service: "oam-admin",
    url: "/material/apply/info",
    method: "POST",
    params: { id },
  });
}

//// 查询企业for 物料申请
export async function getApprovalOrApplyList(data: any) {
  return request<{ result: any }>({
    service: "oam-admin",
    url: "/company/approval_or_apply/list",
    method: "POST",
    data,
  });
}

// 调拨详情物料清单
export async function getApplyDetailList(data: any) {
  return request<Page<BillOfMaterial>>({
    service: "oam-admin",
    url: "/material/apply/detail/list",
    method: "POST",
    data,
  });
}

// 调拨单列表
export async function getApplyDeliveryList(data: any) {
  return request<{ result: TransferOrder[] }>({
    service: "oam-admin",
    url: "/material/apply/delivery/list",
    method: "POST",
    data,
  });
}

// 调拨申请单列表
export async function getWarehouseMaterialApply(data: any) {
  return request<{ result: WarehouseMaterialApply[] }>({
    service: "oam-admin",
    url: "/warehouse/material/apply/qry",
    method: "POST",
    data,
  });
}
// 发货重试-调拨申请单重试
export function getWarehouseMaterialRetry(data: any) {
  return request({
    service: "oam-admin",
    url: "/warehouse/material/apply/initiate/retry",
    method: "POST",
    data,
  });
}

// 收货信息-收货重试
export function getDeliveryMaterialReceiptRetry(data: any) {
  return request({
    service: "oam-admin",
    url: "/material/apply/delivery/receive/confirm/retry",
    method: "POST",
    data,
  });
}

// 发货信息-发货重试
export function getDeliveryMaterialDeliveryRetry(data: any) {
  return request({
    service: "oam-admin",
    url: "/material/apply/delivery/confirm/retry",
    method: "POST",
    data,
  });
}

//仓库列表
export function getWarehouseList(data: any) {
  return request({
    service: "oam-admin",
    url: "/warehouse/list",
    method: "POST",
    data,
  });
}
//仓位列表
export function getMoonPositionList(data: any) {
  return request({
    service: "oam-admin",
    url: "/position/list",
    method: "POST",
    data,
  });
}
// 物料申请单审批
export function materialApplyApprove(data: any) {
  return request({
    service: "oam-admin",
    url: "/material/apply/approve",
    method: "POST",
    data,
  });
}

//最新发货接口
export function saveAndInitiate(data: any) {
  return request({
    service: "oam-admin",
    url: "/warehouse/material/apply/save_and_initiate",
    method: "POST",
    data,
  });
}

// 物料申请保存并发货-标准调拨
export function materialDeliverySaveAndConfirm(data: any) {
  return request({
    service: "oam-admin",
    url: "/material/apply/delivery/save_and_confirm",
    method: "POST",
    data,
  });
}

// 发货详情
export function getMaterialDeliveryDetailList(data: any) {
  return request<Page<ShippingMaterials>>({
    service: "oam-admin",
    url: "/material/apply/delivery/detail/list",
    method: "POST",
    data,
  });
}

// 发货信息-确认收货
export function getDeliveryMaterialReceipt(data: any) {
  return request({
    service: "oam-admin",
    url: "/material/apply/delivery/receive/confirm",
    method: "POST",
    data,
  });
}

// 按钮校验-校验全部发货
export function materialApplyCheckButton(data: any) {
  return request<boolean>({
    service: "oam-admin",
    url: "/material/apply/check_button",
    method: "POST",
    data,
  });
}

export async function getMaterialStockList(data: any) {
  const response = await request({
    service: "oam-admin",
    url: "/material_stock/list",
    method: "POST",
    data,
  });
  if (response.success && response.model?.result) {
    response.model?.result?.forEach((v) => {
      v.label = v?.materialName;
      v.value = v?.materialCode;
      if (v.materialOrigin === 1 && v.platformMaterialCode) {
        v.materialCode = v.platformMaterialCode;
      }
    });
  }
  return response;
}
